import { connect } from 'react-redux';
import {withRouter} from "react-router-dom";
import Menu from '../../components/layout/Menu';

const mapStateToProps = ({ auth }) => ({
  isTeacher: auth.isTeacher,
  token: auth.token,
});

const mapDispatchToProps = () => ({
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));
